import { jsx as _jsx } from "react/jsx-runtime";
import { area, curveMonotoneX } from 'd3-shape';
import { Path15, Path30 } from './styles';
export var AreaLayer = function (_a) {
  var series = _a.series,
    xScale = _a.xScale,
    yScale = _a.yScale;
  var areaGenerator = area().x(function (d) {
    return xScale(d.data.x);
  }).y0(function (d) {
    return yScale(d.data.lowConfidenceYLow);
  }).y1(function (d) {
    return yScale(d.data.lowConfidenceYHigh);
  }).curve(curveMonotoneX);
  var d = areaGenerator(series[1].data);
  return _jsx(Path15, {
    d: d ? d : undefined
  });
};
export var AreaLayer2 = function (_a) {
  var series = _a.series,
    xScale = _a.xScale,
    yScale = _a.yScale;
  var areaGenerator = area().x(function (d) {
    return xScale(d.data.x);
  }).y0(function (d) {
    return yScale(d.data.highConfidenceYLow);
  }).y1(function (d) {
    return yScale(d.data.highConfidenceYHigh);
  }).curve(curveMonotoneX);
  var d = areaGenerator(series[1].data);
  return _jsx(Path30, {
    d: d ? d : undefined
  });
};